import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PrimeModulesModule } from './prime-modules.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeadToolbarComponent } from './modules/header/head-toolbar/head-toolbar.component';
import { AuthHeadComponent } from './modules/Authentication/auth-head/auth-head.component';
import { AuthInterceptor } from './shared/helpers/auth.interceptor';
import { CoinBillingInterceptor } from './shared/helpers/coin-billing.interceptor';
import { NgxSpinnerModule } from "ngx-spinner";
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { RedirectComponent } from './modules/redirect/redirect.component';
import { ViewJobPostDetailsComponent } from './modules/job-posting/view-job-post-details/view-job-post-details.component';
import { FeedbackFormComponent } from './modules/feedback-form/feedback-form.component';

@NgModule({
  declarations: [
    AppComponent,
    HeadToolbarComponent,
    AuthHeadComponent,
    RedirectComponent,
    ViewJobPostDetailsComponent,
    FeedbackFormComponent
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PrimeModulesModule,
    HttpClientModule,
    FormsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,

    MonacoEditorModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CoinBillingInterceptor, multi: true },
    MessageService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
